<template>
  <div class="cell_layer_maps">
    <DxPopup
      id="dx-dialog"
      width="100vw"
      height="calc(100vh - 50px)"
      position="bottom"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      :resize-enabled="false"
      :drag-enabled="false"
      @hidden="$emit('hidden')"
      :wrapper-attr="popupAttributes"
    >
      <template #title>
        <div class="map-filter-title">
          <div class="map-filter-close">
            <img src="@/assets/images/icons/dialog-close-white.svg" @click="buttonCloseEvent" />
          </div>
        </div>
      </template>
      <template #content>
        <div class="parcel-info-container">
          <DxTabPanel
            :data-source="filterTabs"
            :show-nav-buttons="true"
            class="map-filter-tabs"
            :elementAttr="tabPanelAttributes"
            @selection-changed="tabSelectionChanged"
            :defer-rendering="true"
          >
            <template #item="{ data: step }">
              <div>
                <div class="add-new-work" v-if="parcel_group_parcel_uuids.length == 0">
                  <b-button
                    v-show="step == 'LUCRARI'"
                    class="parcel_add_article_icon"
                    variant="outline-secondary"
                    size="sm"
                    pill
                    @click="addNewArticleForParcel"
                    ><img src="@/assets/images/icons/plus.svg"
                  /></b-button>

                  <b-button
                    v-show="step == 'SMAVERTIZARE' && !editMode"
                    class="title_white_button scouting_toggle_edit"
                    variant="outline-secondary"
                    size="sm"
                    pill
                    @click="toggleEditMode"
                    ><img src="@/assets/images/icons/edit.svg"
                  /></b-button>
                  <b-button
                    v-show="step == 'SMAVERTIZARE' && editMode"
                    class="title_white_button scouting_toggle_edit"
                    variant="outline-secondary"
                    size="sm"
                    pill
                    @click="toggleEditMode"
                    ><img src="@/assets/images/icons/dialog-close.svg"
                  /></b-button>

                  <b-button
                    v-show="step == 'SMAVERTIZARE'"
                    class="parcel_add_article_icon ml-10"
                    variant="outline-secondary"
                    size="sm"
                    pill
                    @click="addNewScoutingFromParcel"
                    ><img src="@/assets/images/icons/plus.svg"
                  /></b-button>
                </div>
                <div v-if="step == 'LUCRARI'">
                  <div class="parcel-maps-title">
                    <div v-if="false" class="left_side">
                      <span @click="closeAndSwitchToList">Înapoi la listă</span>
                    </div>
                    <div v-if="false" class="right_side">
                      <span @click="buttonCloseEvent">Înapoi la hartă</span>
                    </div>
                    <div class="works_label">
                      Ai selectat parcela <span>{{ parcel_name }} ({{ parcel_surface }} ha)</span
                      ><span v-if="layer.culture"> - {{ layer.culture.name }}</span>
                    </div>
                  </div>
                  <DxScrollView class="parcel-maps-content" :use-native="true">
                    <works
                      ref="worksModule"
                      usage_mode="LIGHT"
                      :filters="localFilters"
                      :parcel_uuid="parcel_uuid"
                      :parcel_group_uuid="parcel_group_uuid"
                      :parcel_group_parcel_uuids="parcel_group_parcel_uuids"
                      :parcel_name="parcel_name"
                      :parcel_surface="parcel_surface"
                      :season="currentSeason"
                      :start_mode="works_start_mode"
                      @setParentShowAddArticle="setParentShowAddArticle"
                      @showToastMessage="showToastMessage"
                      :showFuelConsumption="true"
                    ></works>
                  </DxScrollView>
                  <div class="parcel_info_continue_add_article_dialog" v-show="works_start_mode == true && addArticleShowing == false">
                    <b-button class="continue_button" variant="outline-secondary" size="sm" pill @click="showAddArticleDialogFunction"
                      >Continuă</b-button
                    >
                    <b-button
                      class="continue_button second_action_button"
                      variant="outline-secondary"
                      size="sm"
                      pill
                      @click="cancelAddProduct"
                      >Anulează</b-button
                    >
                  </div>
                </div>
                <div v-if="step == 'CONSUM'">
                  <div class="parcel-maps-title">
                    <div v-if="false" class="left_side">
                      <span @click="closeAndSwitchToList">Înapoi la listă</span>
                    </div>
                    <div v-if="false" class="right_side">
                      <span @click="buttonCloseEvent">Înapoi la hartă</span>
                    </div>
                    <div v-if="false" class="works_label">
                      Ai selectat parcela <span>{{ parcel_name }} ({{ parcel_surface }} ha)</span>
                    </div>
                  </div>
                  <DxScrollView class="parcel-maps-content-cons" :use-native="true">
                    <parcel-consums
                      v-if="false"
                      :parcel_uuid="parcel_uuid"
                      :parcel_group_parcel_uuids="parcel_group_parcel_uuids"
                      :parcel_name="parcel_name"
                      :parcel_surface="parcel_surface"
                    ></parcel-consums>
                    <consolidate-consum
                      :parcel_uuid="parcel_uuid"
                      :parcel_group_parcel_uuids="parcel_group_parcel_uuids"
                      :parcel_name="parcel_name"
                      :parcel_surface="parcel_surface"
                      :total_weight_kg="consum_total_weight_kg"
                    ></consolidate-consum>
                  </DxScrollView>
                </div>
                <div v-if="step == 'RECOLTA'">
                  <div class="parcel-maps-title">
                    <div v-if="false" class="left_side">
                      <span @click="closeAndSwitchToList">Înapoi la listă</span>
                    </div>
                    <div v-if="false" class="right_side">
                      <span @click="buttonCloseEvent">Înapoi la hartă</span>
                    </div>
                    <div v-if="false" class="works_label">
                      Ai selectat parcela <span>{{ parcel_name }} ({{ parcel_surface }} ha)</span>
                    </div>
                  </div>
                  <DxScrollView class="parcel-maps-content-cons" :use-native="true">
                    <ConsolidateProduction
                      :parcel_uuid="parcel_uuid"
                      :parcel_group_parcel_uuids="parcel_group_parcel_uuids"
                      :parcel_name="parcel_name"
                      :parcel_surface="parcel_surface"
                      :visible="step == 'RECOLTA'"
                      @onProductionLoaded="onProductionLoaded"
                    ></ConsolidateProduction>
                  </DxScrollView>
                </div>
                <div v-if="step == 'SMAVERTIZARE'">
                  <div class="parcel-maps-title">
                    <div class="works_label">
                      Ai selectat parcela <span>{{ parcel_name }} ({{ parcel_surface }} ha)</span
                      ><span v-if="layer.culture"> - {{ layer.culture.name }}</span>
                    </div>
                  </div>
                  <DxScrollView class="parcel-maps-content-scouting" :elementAttr="scrollListAttributesScouting" :use-native="true">
                    <ScoutingList
                      :selectedLayer="selectedLayer"
                      :parcel_uuid="parcel_uuid"
                      :parcel_group_parcel_uuids="parcel_group_parcel_uuids"
                      :season_on_parcel_uuid="season_on_parcel_uuid"
                      :edit_mode="editMode"
                      ref="scoutingListControl"
                    ></ScoutingList>
                    <CreateScouting
                      :show-popup="addScoutingVisibility"
                      @hidden="hideAddNewScoutingFromParcel"
                      @refresh="refreshScoutingListAfterCreate"
                      :parcel_uuid="parcel_uuid"
                      :season_on_parcel_uuid="season_on_parcel_uuid"
                      :selectedLayer="selectedLayer"
                    ></CreateScouting>
                  </DxScrollView>
                </div>
                <div v-if="step == 'FISA PARCELA'">
                  <div class="parcel-maps-title">
                    <div class="works_label">
                      Fișa parcelei <span>{{ parcel_name }} ({{ parcel_surface }} ha)</span
                      ><span v-if="layer.culture"> - {{ layer.culture.name }}</span>
                    </div>
                  </div>
                  <DxScrollView class="parcel-maps-content-cons" :use-native="true">
                    <!-- Parcel Info Content Here -->
                    <div class="parcel-sheet-download">
                      <b-button
                        class="parcel_download_pdf_button"
                        variant="outline-secondary"
                        size="sm"
                        pill
                        :disabled="!parcel_uuid"
                        target="_blank"
                        rel="noopener"
                        @click="documentClick(parcel_uuid, parcel_group_parcel_uuids)"
                      >
                        <img src="~@/assets/images/desktop/icons/controls/pdf.svg" class="icon-svg danger-filter" />
                        <span class="ml-10">Descarcă fișa parcelei</span>
                      </b-button>
                    </div>
                  </DxScrollView>
                </div>
              </div>
            </template>
          </DxTabPanel>
          <add-action-selector
            :showPopup="addActionSelectorVisibility"
            :initialActionCode="addActionSelectorInitialActionCode"
            :forceProductSourceStep="addActionSelectorForceProductSourceStep"
            @hidden="hideAddActionSelector"
            @startAddProduct="onStartAddProduct"
            @startAddProductFromStock="startAddProductFromStock"
            @startAddWork="showManualWorkDialog"
          ></add-action-selector>
          <manual-work-dialog
            :templateData="manualWorkTemplateData"
            :showPopup="maualWorkVisibility"
            :selectedLayer="selectedLayer"
            @hidden="hideManualWork"
            @hideAndRefresh="hideManualWorkAndRefresh"
            @showToastMessage="showToastMessage"
          >
          </manual-work-dialog>
        </div>
      </template>
      <toast-message ref="toastMessage"></toast-message>
    </DxPopup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DxPopup, DxPosition } from "devextreme-vue/popup";
import Works from "../partials/works.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxTabPanel from "devextreme-vue/tab-panel";
import ParcelConsums from "../../../stock-mobile/partials/parcelConsums.vue";
import ScoutingList from "../../../scouting-mobile/partials/scouting-list.vue";
import CreateScouting from "../../../scouting-mobile/dialogs/create-scouting.vue";
import ConsolidateConsum from "../../../../components/Map/consolidateConsum.vue";
import ConsolidateProduction from "../../../../components/Map/consolidateProduction.vue";
import ManualWorkDialog from "./manualWorkDialog.vue";
import AddActionSelector from "./addActionSelector.vue";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import { getServerSubdomain } from "@/helpers/common";
import { normalizeManualWorkInsertResponseData } from "@/helpers/manualWorkInsertNormalization";

export default {
  name: "ParcelInfoDialog",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    templateData: {
      type: Object,
      default: () => {},
    },
    selectedLayer: {
      type: Object,
      default: () => {},
    },
    parcel_uuid: String,
    parcel_group_uuid: String,
    parcel_group_parcel_uuids: {
      type: Array,
      default: () => [],
    },
    parcel_name: String,
    parcel_surface: String,
    season_on_parcel_uuid: String,
    layer: Object,
    filters: Object,
  },
  data() {
    return {
      editMode: false,
      addActionSelectorVisibility: false,
      addActionSelectorInitialActionCode: null,
      addActionSelectorForceProductSourceStep: false,
      pendingManualWorkInsertResponseData: null,
      addScoutingVisibility: false,
      maualWorkVisibility: false,
      addArticleShowing: false,
      manualWorkTemplateData: {},
      localFilters: this.filters ? this.filters : {},
      currentSeason: "",
      popupAttributes: {
        class: "parcel-info-attribute-wrapper",
      },
      tabPanelAttributes: {
        class: "parcel-info-tabs-attribute-wrapper",
      },
      filterTabs: ["LUCRARI", "CONSUM", "RECOLTA", "SMAVERTIZARE", "FISA PARCELA"],
      works_start_mode: false,
      consum_total_weight_kg: null,
      scrollListAttributesScouting: {
        class: "scouting_list_scroller_on_parcel",
      },
    };
  },
  components: {
    DxPopup,
    DxPosition,
    Works,
    DxScrollView,
    DxTabPanel,
    ParcelConsums,
    ManualWorkDialog,
    AddActionSelector,
    ConsolidateConsum,
    ScoutingList,
    CreateScouting,
    ConsolidateProduction,
    ToastMessage,
  },
  computed: {
    ...mapGetters({
      currentDepartment: "auth/currentDepartment",
      seasons: "seasons/seasons",
      departments: "company/departments",
      baseUrlSetting: "settings/baseUrl",
    }),
  },
  watch: {
    showPopup(newVal) {
      console.log("SELECTED LAYER -> ", this.selectedLayer);
      if (newVal == true && this.$refs.worksModule != undefined) {
        this.setCurrentSeason(this.seasons);
        this.loadWorks();
      }
    },
    filters: {
      handler: function (newVal) {
        this.localFilters = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      getDownloadInfo: "smTransactions/getDownloadInfo",
      downloadPdf: "smTransactions/downloadPdf",
      fetchBaseUrl: "settings/getBaseUrl",
    }),
    tabSelectionChanged(option) {
      if (option.addedItems && option.addedItems.length > 0 && option.addedItems[0] == "SMAVERTIZARE") {
        this.$refs.scoutingListControl.fillFirstPage();
      }
    },
    loadWorks() {
      this.$refs.worksModule.applyFilters({
        departments: this.departments.map((d) => d.uuid),
        date_from: "",
        date_to: "",
        works: [],
        machines: [],
        parcels:
          this.parcel_group_parcel_uuids && this.parcel_group_parcel_uuids.length > 0 ? this.parcel_group_parcel_uuids : [this.parcel_uuid],
        products: [],
        src: this.localFilters.src,
        seasons: this.localFilters.seasons,
      });
    },
    buttonCloseEvent() {
      this.$emit("hidden");
    },
    closeAndSwitchToList() {
      this.$emit("closeAndSwitchToList");
    },
    setCurrentSeason(seasons) {
      if (seasons.length === 0) return;

      this.currentSeason = seasons[0].uuid;
      let tmp_currentSeason = seasons[0];
      seasons.forEach((obj) => {
        if (new Date(obj.created_at) > new Date(tmp_currentSeason.created_at)) {
          this.$set(this, "currentSeason", obj.uuid);
        }
      });
    },
    addNewArticleForParcel() {
      this.resetAddActionSelectorState();
      this.addActionSelectorVisibility = true;
    },
    hideAddActionSelector() {
      this.addActionSelectorVisibility = false;
      this.resetAddActionSelectorState();
      this.pendingManualWorkInsertResponseData = null;
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    addNewScoutingFromParcel() {
      this.addScoutingVisibility = true;
    },
    hideAddNewScoutingFromParcel() {
      this.addScoutingVisibility = false;
    },
    refreshScoutingListAfterCreate() {
      this.$refs.scoutingListControl.refreshAfterCreate();
    },
    addArticleFunction() {
      this.works_start_mode = true;
    },
    onStartAddProduct() {
      if (Array.isArray(this.pendingManualWorkInsertResponseData) && this.pendingManualWorkInsertResponseData.length > 0) {
        if (typeof this.$refs.worksModule?.startProductAddAfterManualWork === "function") {
          this.$refs.worksModule.startProductAddAfterManualWork(this.pendingManualWorkInsertResponseData);
        } else {
          this.$refs.worksModule.fillWorkAndAddProductAfterInsert(this.pendingManualWorkInsertResponseData);
          this.$refs.worksModule.fillWorkList(null);
        }
        this.pendingManualWorkInsertResponseData = null;
        return;
      }
      this.addArticleFunction();
    },
    startAddProductFromStock() {
      this.addActionSelectorVisibility = false;

      let hasManualWorkPrefill = false;
      const normalizedManualWorkInsertData = normalizeManualWorkInsertResponseData(this.pendingManualWorkInsertResponseData);
      if (normalizedManualWorkInsertData.length > 0) {
        try {
          window.sessionStorage.setItem(
            "da_manual_work_insert_response_for_stock_consum",
            JSON.stringify(normalizedManualWorkInsertData),
          );
          hasManualWorkPrefill = true;
        } catch (e) {
          console.warn("Could not persist manual work prefill for stock consum", e);
        }
      }

      this.pendingManualWorkInsertResponseData = null;
      this.resetAddActionSelectorState();

      this.$router.push({
        path: "/stock-mobile",
        query: {
          fromApplyArticles: "1",
          startConsum: "1",
          returnTo: "/works/applyArticles",
          manualWorkPrefill: hasManualWorkPrefill ? "1" : "0",
          seasonUuid: this.currentSeason || "",
        },
      });
    },
    showManualWorkDialog() {
      this.maualWorkVisibility = true;
    },
    hideManualWork() {
      this.maualWorkVisibility = false;
    },
    hideManualWorkAndRefresh(addProduct, response_data) {
      this.hideManualWork();
      //this.loadWorks();
      if (addProduct) {
        this.pendingManualWorkInsertResponseData = normalizeManualWorkInsertResponseData(response_data);
        this.addActionSelectorInitialActionCode = "PRODUCT";
        this.addActionSelectorForceProductSourceStep = true;
        this.addActionSelectorVisibility = true;
      }
      this.$refs.worksModule.fillWorkList(null);
    },
    resetAddActionSelectorState() {
      this.addActionSelectorInitialActionCode = null;
      this.addActionSelectorForceProductSourceStep = false;
    },
    showAddArticleDialogFunction() {
      this.$refs.worksModule.showAddArticleDialogFunction();
    },
    cancelAddProduct() {
      this.works_start_mode = false;
      this.$refs.worksModule.deselectAll();
    },
    setParentShowAddArticle(newVal) {
      this.addArticleShowing = newVal;
      if (newVal == false) {
        this.cancelAddProduct();
      }
    },
    onProductionLoaded(payload) {
      this.consum_total_weight_kg = payload && payload.total_weight_kg != null ? payload.total_weight_kg : null;
    },
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    async ensureBaseUrl() {
      const normalize = (url) => (url && url.endsWith("/")) ? url : `${url || ""}/`;

      if (this.baseUrlSetting) {
        return normalize(this.baseUrlSetting);
      }

      try {
        const resolvedBaseUrl = await this.fetchBaseUrl();
        return normalize(resolvedBaseUrl || this.baseUrlSetting || getServerSubdomain());
      } catch (e) {
        return normalize(this.baseUrlSetting || getServerSubdomain());
      }
    },
    async documentClick(parcel_uuid, parcel_group_parcel_uuids) {
      const isGroup = parcel_group_parcel_uuids.length > 0;
      const groupOrParcelUuid = isGroup && this.parcel_group_uuid ? this.parcel_group_uuid : parcel_uuid;
      const baseUrl = await this.ensureBaseUrl();
      const url = `${baseUrl}parcels/sheet/download/${groupOrParcelUuid}/${isGroup ? 1 : 0}`;

      const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      const filename = `parcel_sheet_${timestamp}.pdf`;

      this.downloadPdf({
        url,
        parcel_uuids: isGroup ? parcel_group_parcel_uuids : [parcel_uuid],
        is_group: isGroup ? 1 : 0,
        filename: filename,
        response_type: "blob",
        type: "pdf",
      }).catch((e) => {
        if (e.response.status === 400 || e.response.status === 500) {
          if (e.response.data.errors && e.response.data.errors.error) {
            this.$refs.toastMessage.showError("A apărut o eroare la descărcarea documentului! " + e.response.data.errors.error);
          } else {
            this.$refs.toastMessage.showError("A apărut o eroare la descărcarea documentului!");
          }
        }
      });
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
@import "@/assets/scss/digitalAgenda/parcelInfoDialog.scss";

.parcel-sheet-download {
  padding: 15px;
}
</style>
